import { z } from "zod";

// isolatedDeclarations: define output shape as TS interface, annotate
// Zod const with z.ZodType<Interface> so tsc can emit declarations without
// reading across module boundaries (D-15 paranoid-strict tsconfig).
//
// exactOptionalPropertyTypes: optional fields typed as `T | undefined` to
// match ZodOptional's output type.
//
// Per D-23: fields derived from the pancake HTML reset-button tooltip and the // grep-allow: pancake
// side-vs-stacked layout grid.
// Per D-24: GlobalOptions lives at the top level of the recipe definition.
// Per D-25: print options (printMode, printOptions) and batchSetName vocabulary
// are spread-local — NOT global. They are intentionally absent here.

export interface GlobalOptions {
  theme: "auto" | "light" | "dark";
  layoutMode: "side-by-side" | "stacked";
  zoom?: number | undefined;
  pickerMinSize?: number | undefined;
  cardSize?: "small" | "medium" | "large" | undefined;
}

export const GlobalOptions: z.ZodType<GlobalOptions> = z.strictObject({
  theme: z.enum(["auto", "light", "dark"]),
  layoutMode: z.enum(["side-by-side", "stacked"]),
  // REVIEWS-3 MEDIUM-14: .finite() rejects NaN/Infinity (MEDIUM — z.number() alone accepts NaN).
  zoom: z.number().finite().min(0.5).max(3).optional(),
  // REVIEWS-3 MEDIUM-14: .int().finite() rejects NaN, Infinity, non-integers.
  pickerMinSize: z.number().int().finite().positive().max(1000).optional(),
  cardSize: z.enum(["small", "medium", "large"]).optional(),
});
